import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { debugLogPages } from '../../app/helpers/debugHelper';
import TableHorizontalFullTechnology from './TableHorizontalFullTechnology';
import { startRegisterCompareResult } from '../../app/actions/compareResultActions';

const ComparisonContainerTechnologyByMatrix = () => {
  debugLogPages(':: ComparisonContainerTechnologyByMatrix');

  const { t } = useTranslation();
  const dispatch = useDispatch();

  // Selectores
  const { technologiesS = [] } = useSelector((state) => state.technology);
  const { comparisonTechnologyButtonEnabled } = useSelector((state) => state.configuration);

  // Memoizamos las tecnologías seleccionadas para evitar cálculos innecesarios
  const selectedTechnologies = useMemo(() => 
    technologiesS.filter(tech => tech.isSelected), 
    [technologiesS]
  );

  const countCompare = selectedTechnologies.length;

  useEffect(() => {
    // Sincronizar el contador con el padre
    //setCountCompareTechInContainer(countCompare);

    if (countCompare >= 2) {
      const selectedIds = selectedTechnologies.map(t => t.id).join(';');
      
      const objectCompare = {
        deleted: false,
        compare_ids: selectedIds,
        total_selected: countCompare,
        selected_field: "",
        is_compare_all_fields: true
      };

      dispatch(startRegisterCompareResult(objectCompare));
    }
  }, [countCompare, selectedTechnologies, dispatch]);

  // Si la funcionalidad no está habilitada en config, no renderizamos nada
  if (comparisonTechnologyButtonEnabled !== "true") return null;

  return (
    <div className="comparison-container">
      <div className="flexbox-title">
        <h2>{t("general.compare-technology")}</h2>
      </div>

      <div className="mt-3">
        {countCompare >= 2 ? (
          <>
            <div className="alert alert-info">
              {t("general.exist")} {countCompare} {t("general.to-compare")}
            </div>
            <TableHorizontalFullTechnology data={technologiesS} />
          </>
        ) : (
          <div className="alert alert-warning">
            {/* Mensaje informativo cuando hay 0 o 1 seleccionada */}
            {t("Debe seleccionar al menos dos Casos de Tecnología para realizar la comparación")}
          </div>
        )}
      </div>
    </div>
  );
};

export default ComparisonContainerTechnologyByMatrix;
